import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppWrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/contents.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
